import React from 'react';
import { GameState, UserLanguage } from '../api';
import { useEncounterCatalog } from './useLocationEncounters';
import { Encounter } from './wiki/Encounter';

export function AncientWhisperInfo() {
  return <section className="digital-location-section detail-section" aria-label="Ancient Whisper">
    <h3>Ancient Whisper</h3>
    <p>During the Arkham Encounters phase, an investigator at the Ancient Whisper marker has a special Exhibit Encounter, offering a chance to gain Exhibit items. This replaces their regular encounter, including in streets.</p>
    <p>Only one investigator can resolve Ancient Whisper contact per Arkham Encounters phase. After an Exhibit Encounter is drawn, the marker moves to the street named on that card.</p>
  </section>;
}

export function ExhibitEncounterCatalog({ language, gameState }: { language: UserLanguage; gameState?: GameState }) {
  const { catalog, loading, error, retry } = useEncounterCatalog('Exhibits', language, gameState);
  const cards = catalog?.deckType === 'Exhibits' ? catalog.encounterCards ?? [] : [];
  return <section className="digital-location-section detail-section" aria-label="Exhibit encounter reference">
    <details className="digital-location-encounters">
      <summary>Exhibit Encounters ({loading ? 'loading' : error ? 'unavailable' : cards.length})</summary>
      <p className="digital-location-reference-note">Reference catalog for this game’s expansions. This is not the remaining deck or draw order.</p>
      {error && <div role="alert"><p>{error}</p><button type="button" onClick={retry}>Retry Exhibit encounters</button></div>}
      {!loading && !error && !cards.length && <p>No Exhibit Encounters available.</p>}
      {!error && cards.map((card, index) => <div className="digital-location-encounter" key={`${card.name}-${index}`}>
        <h4>{card.name}</h4>
        <Encounter location="Exhibit Encounters" text={card.description} />
      </div>)}
    </details>
  </section>;
}
